import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { UserCircle } from "@phosphor-icons/react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export function WelcomePopup({ open, onOpenChange }) {
  const { refreshUser } = useAuth();
  const navigate = useNavigate();

  const dismiss = async () => {
    onOpenChange(false);
    try {
      await api.patch("/auth/welcome-seen");
    } catch {
      // ignore
    }
    refreshUser();
  };

  const goToProfile = async () => {
    onOpenChange(false);
    try {
      await api.patch("/auth/welcome-seen");
    } catch {
      // ignore
    }
    refreshUser();
    navigate("/client/profile");
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && dismiss()}>
      <DialogContent className="bg-igc-surface border-igc-gold/20 text-igc-cream max-w-md" data-testid="welcome-popup">
        <DialogHeader>
          <DialogTitle className="font-serif flex items-center gap-2">
            <UserCircle size={22} weight="duotone" className="text-igc-goldText" /> Welcome!
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-1">
          <p className="text-igc-cream text-sm">Please complete your Profile.</p>
          <p className="text-igc-muted text-xs">Update your username, password, and payment information to secure your account.</p>
          <Button data-testid="welcome-popup-go-to-profile-button" onClick={goToProfile} title="Takes you to your Profile page to set your username, password, and payment info." className="w-full bg-igc-gold hover:bg-igc-goldHover text-black">
            Go to My Profile
          </Button>
          <button data-testid="welcome-popup-dismiss-button" onClick={dismiss} title="Closes this popup — you can always update your profile later from the sidebar." className="w-full text-center text-xs text-igc-muted hover:text-igc-goldText transition-colors">
            Maybe later
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
